import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import 'bootstrap/dist/css/bootstrap.css';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import '../../scss/app.scss';
import { LoadScript } from '@react-google-maps/api';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

i18n.init(i18nextConfig);

const ThemeComponent = ({ children, themeName }) => {
  const theme = createMuiTheme({
    palette: {
      type: themeName === 'theme-dark' ? 'dark' : 'light',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

ThemeComponent.propTypes = {
  children: PropTypes.node.isRequired,
  themeName: PropTypes.string.isRequired,
};

const ConnectedThemeComponent = connect(state => ({ themeName: state.theme.className }))(ThemeComponent);

const App = () => {
  useEffect(() => {
    window.addEventListener('load', {});
  }, []);
  return (
    <Provider store={store}>
      <BrowserRouter basename="/">
        <I18nextProvider i18n={i18n}>
          <LoadScript
            googleMapsApiKey="" /* Paste your Google Maps Api Key here */
          >
            <ScrollToTop>
              <ConnectedThemeComponent>
                <NotificationContainer />
                <Router />
              </ConnectedThemeComponent>
            </ScrollToTop>
          </LoadScript>
        </I18nextProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
